import React from 'react';
import { Business, Logout } from '@mui/icons-material';
import {
  Box, Button, Chip, List, ListItemButton, ListItemIcon, ListItemText, Paper, Typography,
} from '@mui/material';
import { signOut } from 'firebase/auth';

import { auth } from '../firebase';
import { cambiarDeEmpresa } from '../empresa';
import { irAlHub } from '../hub';

const ROL = { admin: 'Administrador', contador: 'Contador / operador', solo_lectura: 'Solo consulta' };

/** Quien es usuario de varias empresas escoge con cuál trabajar (DA-16).
 *  Mismo diseño que el CRM (paginas/EscogerEmpresa.jsx). */
export default function EscogerEmpresa({ empresas }) {
  return (
    <Box sx={{ minHeight: '100vh', display: 'grid', placeItems: 'center', bgcolor: '#0f172a', p: 2 }}>
      <Paper sx={{ p: { xs: 3, sm: 5 }, width: '100%', maxWidth: 460 }}>
        <Typography sx={{ fontSize: 30, fontWeight: 800, color: '#1e3a5f', letterSpacing: -0.5,
                          textAlign: 'center' }}>
          NARA ERP
        </Typography>
        <Typography sx={{ color: 'text.secondary', mb: 2, fontSize: 14, textAlign: 'center' }}>
          ¿Con qué empresa vas a trabajar?
        </Typography>
        <List sx={{ border: '1px solid #e2e8f0', borderRadius: '10px', py: 0, overflow: 'hidden' }}>
          {empresas.map((e, i) => (
            <ListItemButton key={e.identificador} divider={i < empresas.length - 1}
                            onClick={() => cambiarDeEmpresa(e.identificador)}>
              <ListItemIcon sx={{ minWidth: 36, color: '#1e3a5f' }}><Business /></ListItemIcon>
              <ListItemText primary={e.nombre} secondary={ROL[e.rol] || e.rol}
                            primaryTypographyProps={{ fontSize: 14, fontWeight: 600 }}
                            secondaryTypographyProps={{ fontSize: 12 }} />
              {e.demo && <Chip size="small" label="Demo" variant="outlined" color="secondary"
                               sx={{ height: 20, fontSize: 10.5 }} />}
            </ListItemButton>
          ))}
        </List>
        <Button fullWidth size="small" startIcon={<Logout />} sx={{ mt: 2, color: 'text.secondary' }}
                onClick={async () => { await signOut(auth); localStorage.clear(); irAlHub(); }}>
          Salir
        </Button>
      </Paper>
    </Box>
  );
}
